module.exports = __webpack_public_path__ + "assets/img/wenJiangBiaoDi.8600264b.png";